import { FiClock } from "react-icons/fi";
import { RiEyeLine, RiMoneyDollarCircleLine } from "react-icons/ri";
import { Badge, Col, Row } from "reactstrap";
import './PropertyCard.css';
import { API_URL, STORAGE_URL } from "../../utils/constants";
import moment from "moment";
import 'moment/locale/ar';
import { generateKey, printPrice, printPropertyDescription, tField } from "../../utils/helpers";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IconButton from "../Buttons/Icon";
import { SlPencil } from "react-icons/sl";
import { BsTrash2 } from "react-icons/bs";
import { IoReload, IoReloadOutline } from "react-icons/io5";
import { useState } from "react";
import { toast } from "react-toastify";
import { CiLocationArrow1, CiPlay1 } from "react-icons/ci";
import DeletePropertyModal from "../Modals/DeleteProperty";
import { GoPin } from "react-icons/go";
import BoostPropertyModal from "../Modals/BoostProperty";
import { useTranslation } from "react-i18next";
import RepostPropertyModal from "../Modals/RepostProperty";

function PropertyCard({property, showViews, refreshFunction}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [pauseLoading, setPauseLoading] = useState(false);
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const [boostModalShown, setBoostModalShown] = useState(false);
  const [repostModalShown, setRepostModalShown] = useState(false);

  if(!property) return null;

  const pause = (status) => {
    setPauseLoading(true);
    fetch(API_URL+'/user/properties/'+status+'/'+property.id, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.success) {
        if(status === 'activate')
          toast.success('تم تفعيل الإعلان بنجاح');
        else if(status === 'pause')
          toast.success('تم ايقاف الإعلان بنجاح');

        if(refreshFunction) refreshFunction();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      setPauseLoading(false);
    });
  }

  return(
    <div className={'property-card-container border mb-3 position-relative'+ (property?.is_premium ? ' premium' : '')}>
      <Link to={'/property/'+property?.id} state={{ property }} className="stretched-link"></Link>
      {Number(property?.is_premium) === 1 &&
        <Badge 
          color="primary" 
          className="position-absolute top-0 end-0 m-2 fw-light rounded-pill px-2 py-1"
        >
          {t('property.premium_badge')}
        </Badge>
      }
      <Row>
        <Col lg="2" md="3" xs="3">
          {property?.images?.length > 0 ?
            <img src={STORAGE_URL+property.images[0].image_path} width={'100%'} alt="" />
          :
            property?.videos?.length > 0 && property.videos[0].thumbnail_path ? 
              <img src={STORAGE_URL+property.videos[0].thumbnail_path} width={'100%'} alt="" />
            :
              <img src={require('../../assets/images/default-office.png')} width={'100%'} alt="" />
          }
        </Col>
        <Col lg="10" md="9" xs="9" className="ps-2 pe-3">
          <h5 className="mt-3">{ tField(property, 'title') }</h5>
          
          <div className="d-flex align-items-center">
            {property?.price &&
              <div className="me-2 fw-bold">
                <RiMoneyDollarCircleLine className="text-primary" size={18} />{' '}
                <small>{ printPrice(property?.price) } د.ك</small>
              </div>
            }
            <div className="me-2">
              <FiClock size={18} className="text-primary" />{' '}
              <small>
                {property?.created_at &&
                  moment(property.created_at)
                    .fromNow()
                    .replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
                }
              </small>
            </div>
            {showViews &&
              <div>
                <RiEyeLine size={18} className="text-primary" /> <small>{ property?.views || 0 }</small>
              </div>
            }
          </div>
        </Col>
      </Row>

      <p className="small text-muted mb-2 ps-3 pe-3">
        { printPropertyDescription(property?.description_ar) }
      </p>

      {Number(property?.user_id) === Number(JSON.parse(localStorage.getItem('user'))?.id) &&
      location.pathname.includes('/my_properties') &&
        <>
          <hr />
          <Row className="pb-2 mt-2 mx-1 position-relative justify-content-center" style={{zIndex: 999}}>
            {property?.status !== 'active' ?
              <Col xs="2">
                <IconButton
                  size="sm"
                  outline
                  color="success"
                  onClick={() => pause('activate')}
                  loading={pauseLoading}
                  disabled={pauseLoading}
                  block
                >
                  <IoReloadOutline />
                </IconButton>
              </Col>
            :
              <Col xs="2">
                <IconButton
                  size="sm"
                  outline
                  color="info"
                  onClick={() => pause('pause')}
                  loading={pauseLoading}
                  disabled={pauseLoading}
                  block
                >
                  <CiPlay1 />
                </IconButton>
              </Col>
            }

            <Col xs="2">
              <IconButton
                size="sm"
                outline
                color="dark"
                onClick={() => setRepostModalShown(true)}
                className="mb-2"
                block
              >
                <IoReload />
              </IconButton>
            </Col>

            <Col xs="2">
              <IconButton
                size="sm"
                outline
                color="warning"
                onClick={() => setBoostModalShown(true)}
                className="mb-2"
                block
              >
                <GoPin />
              </IconButton>
            </Col>

            <Col xs="2">
              <IconButton
                size="sm"
                outline
                color="secondary"
                onClick={() => navigate('/my_properties/create', { state: { property } })}
                className="mb-2"
                block
              >
                <SlPencil />
              </IconButton>
            </Col>

            <Col xs="2">
              <IconButton
                size="sm"
                outline
                color="danger"
                onClick={() => setDeleteModalShown(true)}
                block
              >
                <BsTrash2 />
              </IconButton>
            </Col>
          </Row>
        </>
      }

      <DeletePropertyModal 
        isOpen={deleteModalShown}
        toggle={() => setDeleteModalShown(!deleteModalShown)} 
        propertyId={property?.id}
        onSuccess={() => {
          navigate('/my_properties?p='+generateKey());
        }}
      />

      <BoostPropertyModal 
        isOpen={boostModalShown}
        toggle={() => setBoostModalShown(!boostModalShown)} 
        propertyId={property?.id}
        onSuccess={() => {
          navigate('/my_properties?p='+generateKey());
        }}
      />

      <RepostPropertyModal 
        isOpen={repostModalShown}
        toggle={() => setRepostModalShown(!repostModalShown)} 
        propertyId={property?.id}
        onSuccess={() => {
          navigate('/my_properties?p='+generateKey());
        }}
      />
    </div>
  );
}

export default PropertyCard;